import { Link } from "react-router-dom";
import BrandLogo from "@/components/layout/BrandLogo";

const STEPS = [
  {
    icon: "ri-smartphone-line",
    title: "Abre este enlace en tu celular",
    desc: "Escribe attd.app/ingreso en el navegador de tu teléfono (Chrome o Safari).",
  },
  {
    icon: "ri-add-circle-line",
    title: "Agrega a tu pantalla de inicio",
    desc: "Toca el menú del navegador y elige \"Agregar a pantalla de inicio\" para guardar el ícono.",
  },
  {
    icon: "ri-lock-2-line",
    title: "Ingresa con tu cuenta ATDD",
    desc: "Tu administrador (Juanka) te crea la cuenta. Entra y empieza a vender y a chulear.",
  },
];

// Ruta pública de invitación para asesores (sin autenticación).
const IngresoPage = () => (
  <div className="attd-app-bg min-h-screen w-full">
    <div className="mx-auto max-w-[720px] px-4 md:px-6 py-10 md:py-16">
      <div className="flex justify-center animate-fade-up">
        <BrandLogo />
      </div>

      <div className="text-center mt-8 animate-fade-up">
        <span className="inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-wider text-accent-300">
          <i className="ri-user-add-line" /> Invitación a la red de asesores
        </span>
        <h1 className="editable-title text-2xl md:text-4xl font-extrabold tracking-tight mt-3">
          Lleva tu tienda Amway en el bolsillo
        </h1>
        <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-xl mx-auto">
          Instala el portal del asesor en tu celular y gestiona tu inventario en consignación,
          registra tus ventas y pide productos por encargo, todo en tiempo real.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-10">
        {STEPS.map((s, i) => (
          <div key={s.title} className="glass-panel rounded-lg p-5 animate-fade-up">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-lg bg-primary-500/25 text-accent-200 flex items-center justify-center shrink-0">
                <i className={`${s.icon} text-xl`} />
              </span>
              <span className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-xs font-bold">
                {i + 1}
              </span>
            </div>
            <h2 className="editable-title text-base font-bold mt-4">{s.title}</h2>
            <p className="text-xs md:text-sm text-foreground-600 mt-2">{s.desc}</p>
          </div>
        ))}
      </div>

      <div className="glass-panel-strong rounded-xl p-6 md:p-7 border-accent-500/25 mt-8 text-center animate-fade-up">
        <p className="text-sm text-foreground-700">
          ¿Ya tienes tu cuenta creada por el administrador?
        </p>
        <Link
          to="/acceso"
          className="mt-4 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-foreground-950 text-sm font-semibold whitespace-nowrap cursor-pointer"
        >
          <i className="ri-login-box-line" /> Ingresar a mi portal
        </Link>
        <p className="text-[11px] text-foreground-500 mt-3">
          Si aún no tienes cuenta, pídele a Juanka que te cree una desde el panel de administrador.
        </p>
      </div>
    </div>
  </div>
);

export default IngresoPage;